import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** Product cards from a product source (new, on sale, a category, top rated or hand-picked). */
export const schema: ComponentSchema = {
  type: 'product-rail',
  label: 'Product rail',
  description: 'A swipe row (with arrows) or grid of product cards from new arrivals, deals, a category or your own pick.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Product cards' }],
  commonFields: [
    ...headingFields({ eyebrow: 'Just in', title: 'New arrivals', subtitle: 'The latest additions to the store.' }),
    { key: 'source', label: 'Products', type: 'product-source', default: { source: 'new', limit: 8 } },
    {
      key: 'layout',
      label: 'Layout',
      type: 'select',
      options: [
        { label: 'Swipe row with arrows', value: 'rail' },
        { label: 'Grid (2 columns on phones, 5 on desktop)', value: 'grid' },
      ],
      default: 'rail',
    },
    { key: 'showViewAll', label: 'Show “View all”', type: 'boolean', default: true },
    { key: 'viewAllLabel', label: '“View all” text', type: 'string', default: 'View all', dependency: { field: 'showViewAll', value: true } },
    ...SECTION_STYLE_FIELDS,
  ],
}
